import React, { useState, useEffect } from "react";
import {
  Breadcrumbs,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Link as LinkBread,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  Delete,
  Edit,
} from "@material-ui/icons";
import { useSnackbar } from "notistack";
import {Link} from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import ApiServer from "../../../../resources/conn/ApiServer";
import GlobalEvents from "../../../../resources/event/GlobalEvents";
import ModalDialog from "../../../../resources/component/general/modal/ModalDialog";
import ClientsCreate from "./../formulary/Create";
import ClientsUpdate from "./../formulary/Update";

const useStyles = makeStyles((theme) => ({
  breadcrumbsBar: {
    padding: 15,
  },
  primaryName: {
    border: 0,
    textDecoration:null,
    color: '#000000',
  },
  secondaryName: {
    textDecoration:null,
    color: '#777777',
  },
  card: {
    maxWidth: 500,
    // backgroundColor: '#fc4600',
  },
  cardText: {
    color: '#444444',
  },
  media: {
    height: 180,
    backgroundColor: '#cccccc',
  },
}));

export default function ClientsListSimple() {

  const classes = useStyles();
  const {enqueueSnackbar} = useSnackbar();

  const [openEdit, setOpenEdit] = useState(false);
  const [openNew, setOpenNew] = useState(false);

  const [id, setId] = useState(null);
  const [list, setList] = useState([]);
  const [listFilter, setListFilter] = useState([]);
  const [filter, setFilter] = useState('');

  const listage = () => {
    new ApiServer()
      .get("clients", "get")
      .then((e) => {
        if (e.statusText === "OK" && e.data !== undefined ) {
          setList(e.data);
          setListFilter(e.data);
        }else{
          setList([]);
          setListFilter([]);
        }
      })
      .catch((err) => {
        console.log(err.statusText, err);
      });
  };

  const onNew = () => {
    setOpenNew( true ); 
  };

  const onEdit = ( event, { id } ) => {
    event.preventDefault();
    event.stopPropagation();
    setId( id );
    setOpenEdit( true ); 
  };

  const onDelete = ( event, { id } ) => {

    event.preventDefault();
    event.stopPropagation();

    if(!window.confirm('Delete item?')) return;
    new ApiServer().delete( 'clients', `delete/${id}` ).then(( res )=>{
      console.log( res );
      if( res.statusText === 'OK' ){
        listage();
        enqueueSnackbar('Deleted',{variant:'success'});
      }
    }).catch((err)=>{
      enqueueSnackbar('Error',{variant:'error'});
    });
  
  };

  const onChangeFilter = ( filter ) => {
    if( !filter ) setListFilter( list ); 
    setListFilter(
      list.filter((el) => String(el.client_name).toLowerCase().indexOf( String(filter).toLowerCase() ) > -1 )
    );
  };

  useEffect(() => {
    
    listage();
    GlobalEvents.on('updateClients',listage);
    return ()=>{
      GlobalEvents.off('updateClients',listage);
    }
  }, []);

  return (
    <React.Fragment>
      <Container component="main">

        <Grid container style={{padding:15}}>
          <Grid item xs={6}>
            <Breadcrumbs aria-label="breadcrumb" style={{margin:5}}>
              <LinkBread color="inherit" href="/">
                Home
              </LinkBread>
              <Typography color="textPrimary">
                Clients
              </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid xs={6} container justify="flex-end">
            <IconButton aria-label="add" onClick={()=>onNew()} title="Add">
              <AddIcon fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item xs={12} style={{marginTop:5}}>
            <TextField 
              InputLabelProps={{ shrink: true }} shrink
              autoComplete="clientsfilter"
              name="clients_filter"
              variant="outlined"
              fullWidth
              label="Search"
              size="small"
              onChange={(event)=>{ setFilter(event.target.value); onChangeFilter(event.target.value) }}
              value={filter}
              />
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{padding:15}}>
          {listFilter.map((el) => (
            <Grid item xs={12} sm={6} md={4}>
              <Link
                to={{
                  pathname: `/client/brand/${el.id}`,
                  client_id: `${el.id}`,
                  }}
                style={{ textDecoration: 'none' }}
              >
                <Card className={classes.card}>
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={process.env.REACT_APP_IMAGE_HOST && el.file_name? process.env.REACT_APP_IMAGE_HOST + '200/' + el.file_name : '/assets/images/image-not-found.png'}
                      title={el.client_name}
                    />
                    <CardContent>
                      <Typography gutterBottom component="h5" className={classes.cardText}>
                        {el.client_name}
                      </Typography>
                      {/* <Typography variant="body2" color="textSecondary" component="p" className={classes.cardText}>
                        {el.year}
                      </Typography> */}
                    </CardContent>
                  </CardActionArea>
                  {/* <CardActions>

                    <IconButton aria-label="edit" onClick={(e)=>onEdit(e, el)} title="Edit">
                      <Edit />
                    </IconButton>

                    <IconButton edge="end" aria-label="delete" onClick={(e)=>onDelete(e, el)} title="Delete">
                      <Delete />
                    </IconButton>

                    <Button size="small" color="primary">
                      Edit
                    </Button>
                    <Button size="small" color="primary">
                      Delete
                    </Button>

                  </CardActions> */}
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>

        <List dense={true}>
          {listFilter.map((el) => (
            <Link
              to={{
                pathname: `/client/brand/${el.id}`,
                client_id: `${el.id}`,
              }}
              style={{ textDecoration: 'none' }}
            >
              <ListItem key={el.id} button>
                <ListItemAvatar>
                  <img src={process.env.REACT_APP_IMAGE_HOST && el.file_name? process.env.REACT_APP_IMAGE_HOST + '100/' + el.file_name : '/assets/images/image-not-found.png'} 
                  alt="Client" style={{maxWidth:'50px', maxHeight:'50px', borderRadius:'7px', marginRight:'20px'}}/>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="body" className={classes.primaryName}>{el.client_name}</Typography>}
                  secondary={`${el.website || ''}`}
                />
                <ListItemSecondaryAction>

                  <IconButton aria-label="edit" onClick={ event => onEdit( event, el ) }
                  title="Edit">
                    <Edit />
                  </IconButton>

                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={ event => onDelete( event, el )}
                    title="Delete">
                    <Delete />
                  </IconButton>

                </ListItemSecondaryAction>
              </ListItem>
            </Link>
          ))}
        </List>

        <ModalDialog open={openEdit} setOpen={(v)=>setOpenEdit(v)} title='Update'>
          <ClientsUpdate data={{id:id}} setOpen={(v)=>{ if(v === false) setOpenEdit(v) }}/>
        </ModalDialog>

        <ModalDialog open={openNew} setOpen={(v)=>setOpenNew(v)} title='Add'>
          <ClientsCreate data={{}} setOpen={(v)=>{ if(v === false) setOpenNew(v) }}/>
        </ModalDialog>

        {/* <Nestable 
            collapsed={false}
            items={processTree} 
            renderItem={renderItem2} 
            // ref={el => this.refNestable = el}        
        /> */}

      </Container>
    </React.Fragment>
  );
}
